export class ButtonBuilder {
  private readonly button: HTMLElement;

  constructor() {
    this.button = this.setupButton();
  }

  private setupButton() {
    const button = document.createElement('button');
    button.setAttribute('type', 'button');
    return button;
  }

  withText(text: string) {
    const p = document.createElement('p');
    p.innerText = text;
    this.button.append(p);
    return this;
  }

  withIcon(icon: string) {
    const runCodeBracketIcon = document.createElement('svg');
    runCodeBracketIcon.innerHTML = icon;
    this.button.append(runCodeBracketIcon);
    return this;
  }

  withId(id: string) {
    this.button.setAttribute('id', id);
    return this;
  }

  withOnClick(onClick: () => void | Promise<void>) {
    this.button.addEventListener('click', () => onClick());
    return this;
  }

  build() {
    return this.button;
  }
}
